import React from 'react'
import { Container as ReactstrapContainer, ContainerProps } from 'reactstrap'

export const Container: React.FC<ContainerProps> = props => {
  return <ReactstrapContainer {...props} />
}
